<template>
  <div>
    <a-drawer
      title="Create a new client"
      width="60%"
      @close="onClose"
      :visible="isDrawerVisible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
    <a-spin size="large" :spinning="loading">
      <a-form :form="form" :layout="formLayout" style="margin-top:1em;" class="create_tenant">
        <a-text-field
          varName="client_name"
          varLabel="Client Name"
          :varRequired="true"
          :formLayout="formLayout"
          :size="size"
        />
        <a-text-area-field
        varName="client_description"
        varLabel="Client Description"
        :varRequired="true"
        :formLayout="formLayout"
        :size="size"
        />
        <a-select-field
        varName="application_type"
        varLabel="Application Type"
        :varRequired="true"
        :formLayout="formLayout"
        :size="size"
        :varOptions="options.application_type.choices"
        type="schema"
        />
        <a-switch-field
          varName="is_first_party"
          varLabel="First Party"
          :varRequired="false"
          :formLayout="formLayout"
          :varInitial="true"
          :size="size"
          description="First party apps can skip the consent screen"
        />
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Create Client"
          styled="margin-top:0.5em;"
        />
      </a-form>
    </a-spin>
    </a-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: "vertical",
      size: "large",
      loading: false
    };
  },
  methods: {
    onClose() {
      this.$store.dispatch("ui/hideDrawer", {
        drawer_name: "create_client"
      });
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true;
            await this.$store.dispatch("tenant/createItem", {
              endpoint: "clients",
              data: values
            });
            this.loading = false;
            await this.$store.dispatch("ui/hideDrawer", {
              drawer_name: "create_client"
            });
            await this.$store.dispatch("tenant/getItems", {
                endpoint: "clients"
            });
            await this.$notification.open({
                message: 'New client created!',
                description: 'Please configure your new client.',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
            this.loading = false;
            form.setFields({
              slug: {
                value: values.slug,
                errors: [new Error(`${error.response.data.slug[0]}`)]
              }
            });
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },
  computed: {
    isDrawerVisible() {
      return this.$store.state.ui.create_client;
    },
    options() {
      return this.$store.state.tenant.clients_options.actions.POST ?
      this.$store.state.tenant.clients_options.actions.POST : {};
    }
  }
};
</script>
